<template>
    <div id="pictures-viewer" v-if="picturesList.length !== 0">
        <span class="arrow left-arrow"
              v-show="hasPrev"
              @click="prev()"
        ></span>
        <div class="picture-box"
             :class="{'picture-box-center': onlyOnePicture}"
             v-for="(picture, index) in picturesList"
             ref="pictureBox"
             :style="`transform: translateX(-${offset}px);`"
        >
            <img :src="picture.image"
                 :class="{'inactive': !currentImages.includes(picture.id)}"
                 @click="show(index)"
            />
        </div>
        <span class="arrow right-arrow"
              v-show="hasNext"
              @click="next()"
        ></span>
    </div>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>

    $min-width-l: 1400px;

    $picture-box-width: 280px;
    $picture-box-margin-s: 5px;
    $picture-box-margin-l: 15px;

    #pictures-viewer {
        white-space: nowrap;
        position: relative;
        display: inline-block;
        width: $picture-box-width + 4 * $picture-box-margin-s;

        @media (min-width: $min-width-l) {
            width: $picture-box-width + 4 * $picture-box-margin-l;
        }

        // Magic to center overflowed div horizontally
        margin-left: 50%;
        transform: translateX(-50%);

        .picture-box {
            display: inline-block;
            position: relative;
            width: $picture-box-width;
            height: 200px;
            margin: 0 $picture-box-margin-s;
            transition: transform 0.5s;

            @media (min-width: $min-width-l) {
                margin: 0 $picture-box-margin-l;
            }

            img {
                transition: all 0.5s;
                max-width: 100%;
                max-height: 100%;
                user-select: none;
                position: absolute;
                margin: auto;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
            }

            img:not(.inactive) {
                cursor: pointer;
            }

            .inactive {
                opacity: 0.1;
            }

            &.picture-box-center {
                width: 100%;
            }
        }

        .arrow {
            position: absolute;
            width: 34px;
            height: 34px;
            top: 83px;
            z-index: 5;
            cursor: pointer;

            &.right-arrow {
                right: -40px;
                background: url('../../../images/btn/arrow-right.png') no-repeat center center;

                @media (min-width: $min-width-l) {
                    right: -50px;
                }
            }

            &.left-arrow {
                left: -40px;
                background: url('../../../images/btn/arrow-left.png') no-repeat center center;

                @media (min-width: $min-width-l) {
                    left: -50px;
                }
            }
        }
    }
</style>

<script>
    import debounce from 'lodash.debounce';

    export default {
        name: 'PicturesViewer',
        props: {
            picturesList: {
                type: Array,
                required: true,
            },
            firstImageIdx: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                boxWidth: 0,
                resizeHandler: debounce(this.recalculateBoxWidth, 200),
            };
        },
        mounted() {
            this.recalculateBoxWidth();
            window.addEventListener('resize', this.resizeHandler);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.resizeHandler);
        },
        computed: {
            currentImages() {
                return this.picturesList.slice(this.firstImageIdx, this.firstImageIdx + 1).map(img => img.id);
            },
            offset() {
                return this.firstImageIdx * this.boxWidth;
            },
            onlyOnePicture() {
                return this.picturesList.length === 1;
            },
            hasPrev() {
                return this.firstImageIdx > 0;
            },
            hasNext() {
                return this.picturesList.length > this.firstImageIdx + 1;
            },
        },
        methods: {
            next() {
                this.firstImageIdx += 1;
                this.$emit('update:firstImageIdx', this.firstImageIdx);
            },
            prev() {
                this.firstImageIdx -= 1;
                this.$emit('update:firstImageIdx', this.firstImageIdx);
            },
            recalculateBoxWidth() {
                if (this.$refs.pictureBox) {
                    this.boxWidth = $(this.$refs.pictureBox[0]).outerWidth(true);
                }
            },
            show(index) {
                if (index === this.firstImageIdx) {
                    this.$emit('show', index);
                }
            },
        },
    };
</script>



// WEBPACK FOOTER //
// PicturesViewer.vue?7e2261e4